import { Reducer } from 'redux';

// Types
import { TollState, TollTypes } from './types';

const INITIAL_STATE: TollState = {
  tollData: {
    id: '',
    name: '',
    value: 0,
    createdAt: '',
    updatedAt: '',
    stopId: '',
    transportOperatorId: '',
  },
  tollsList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<TollState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST TOLLS
    case TollTypes.LIST_TOLLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tollsList: INITIAL_STATE.tollsList,
      };
    case TollTypes.LIST_TOLLS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tollsList: action.payload.tollsList,
        totalCount: action.payload.totalCount,
      };
    case TollTypes.LIST_TOLLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tollsList: INITIAL_STATE.tollsList,
      };

    // CASES GET TOLL
    case TollTypes.GET_TOLL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tollData: INITIAL_STATE.tollData,
      };
    case TollTypes.GET_TOLL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tollData: action.payload.tollData,
      };
    case TollTypes.GET_TOLL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tollData: INITIAL_STATE.tollData,
      };

    // CASES FILTER TOLLS
    case TollTypes.FILTER_TOLLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tollsList: INITIAL_STATE.tollsList,
      };
    case TollTypes.FILTER_TOLLS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tollsList: action.payload.tollsList,
        totalCount: action.payload.totalCount,
      };
    case TollTypes.FILTER_TOLLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tollsList: INITIAL_STATE.tollsList,
      };

    // CASES CREATE TOLL
    case TollTypes.CREATE_TOLL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tollData: INITIAL_STATE.tollData,
      };
    case TollTypes.CREATE_TOLL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tollData: action.payload.tollData,
      };
    case TollTypes.CREATE_TOLL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tollData: INITIAL_STATE.tollData,
      };

    // CASES UPDATE TOLL
    case TollTypes.UPDATE_TOLL_REQUEST:
      return { ...state, loading: true, error: false };
    case TollTypes.UPDATE_TOLL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tollData: action.payload.tollData,
      };
    case TollTypes.UPDATE_TOLL_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE TOLL
    case TollTypes.DELETE_TOLL_REQUEST:
      return { ...state, loading: true, error: false };
    case TollTypes.DELETE_TOLL_SUCCESS:
      return { ...state, loading: false, error: false };
    case TollTypes.DELETE_TOLL_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return state;
  }
};

export default reducer;
